/*
* Project: LegalPlace assistant
* File: src/redux/actions/input_context.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

const IC_SET_OPTION = 'IC_SET_OPTION';
const IC_SET_VARIABLE = 'IC_SET_VARIABLE';


function icSetOption(id) {
  return {
    type: IC_SET_OPTION,
    optionid: id,
  };
}


function icSetVariable(id) {
  return {
    type: IC_SET_VARIABLE,
    varid: id,
  };
}

export {
  IC_SET_OPTION,
  IC_SET_VARIABLE,
  icSetOption,
  icSetVariable,
};



// WEBPACK FOOTER //
// ./src/redux/actions/input_context.js